module.exports = __webpack_public_path__ + "img/arrow-tip-down.bef3a6ec.svg";